/*
 * Copyright (c) 2015 Macrofocus GmbH. All Rights Reserved.
 */
package org.molap.subset

/**
 * Created by luc on 16/05/15.
 */
class DimensionEvent<R>(dimension: Dimension<R>, filtered: Iterable<R>?, unfiltered: Iterable<R>?) {
    private val dimension: Dimension<R>
    val filtered: Iterable<R>?
    val unfiltered: Iterable<R>?
    fun getDimension(): Dimension<R> {
        return dimension
    }

    init {
        this.dimension = dimension
        this.filtered = filtered
        this.unfiltered = unfiltered
    }
}